import { Injectable } from '@angular/core';
import { RestCallService } from '../../../../core/services/rest-call/rest-call.service';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { NotificationService } from 'src/app/core/services/notification/notification.service';
import { TranslateApplicationService } from '../../../../core/translate/translate-application-service';
import { CognitoService } from 'src/app/core/services/cognito/cognito.service';
import { IActivities } from '../Interfaces/IActivities';
import { IEHSExams } from '../Interfaces/IEHSExams';

@Injectable({
	providedIn: 'root',
})
export class ActivitiesService extends RestCallService {
  public dataToSend: IActivities = {
    pkactivity: 0,
    pkactivitiesexam: 0,
    fksite: 0,
    fkehsexam: 0,
    sitename: '',
    activity: '',
    dc3: false,
    chemicalsubstance: false,
    available: false,
    configured: false,
    creationdate: new Date,
    strcreationdate: '',
    fkemployeecreator: 0,
    lastupdated: new Date,
    strlastupdated: '',
    fkemployeeupdater: 0,
    employeecreatorname: '',
    employeeupdatername: '',
    username: '',
    critical_work:false
    };

  constructor(
    public httpClient: HttpClient,
    private cognitoService: CognitoService,
    public toastr: ToastrService,
    public notificationService: NotificationService,
    public translate: TranslateApplicationService,
  ) {     
      super(httpClient, 'JACSapi', toastr, notificationService, translate);
  }
  
  GetAvailableActivities() {
    if (!this.cognitoService.IsAuhtenticated())
      this.cognitoService.LogOut();
    this.dataToSend.fksite = Number(localStorage.getItem('pksite'));
    return this.post<IActivities[]>('/api/Activities/GetAvailableActivities', this.dataToSend);
  }

  public GetList() {
    if (!this.cognitoService.IsAuhtenticated())
      this.cognitoService.LogOut();
    this.dataToSend.fksite = Number(localStorage.getItem('pksite'));
    return this.post<IActivities[]>('/api/Activities/GetActivities', this.dataToSend);
  }

  public CreateActivity(data: any) {
    if (!this.cognitoService.IsAuhtenticated())
      this.cognitoService.LogOut();
    this.dataToSend.activity = data.activity;
    this.dataToSend.dc3 = data.dc3;
    this.dataToSend.chemicalsubstance = data.chemicalsubstance;
    this.dataToSend.critical_work = data.chkcriticalwork;
    this.dataToSend.fksite = Number(localStorage.getItem('pksite'));
    return this.post('/api/Activities/CreateActivity', this.dataToSend);
  }
    
  public UpdateActivity(data: any) {
    if (!this.cognitoService.IsAuhtenticated())
      this.cognitoService.LogOut();
    this.dataToSend.pkactivity = data.pkactivity;
    this.dataToSend.activity = data.activity.trim();
    this.dataToSend.dc3 = data.dc3;
    this.dataToSend.chemicalsubstance = data.chemicalsubstance;
    this.dataToSend.critical_work = data.critical_work;
    this.dataToSend.fksite = Number(localStorage.getItem('pksite'));
    return this.put('/api/Activities/UpdateActivity', this.dataToSend);
  }

  public ChangeStatusActivity(data: any) {
    if (!this.cognitoService.IsAuhtenticated())
      this.cognitoService.LogOut();
    this.dataToSend.pkactivity = data.pkactivity;
    this.dataToSend.available = data.available;
    this.dataToSend.fksite = Number(localStorage.getItem('pksite'));
    return this.put('/api/Activities/ChangeStatusActivity', this.dataToSend);
  }

  public ChangeStatusDc3(data: any) {
    if (!this.cognitoService.IsAuhtenticated())
      this.cognitoService.LogOut();
    this.dataToSend.pkactivity = data.pkactivity;
    this.dataToSend.dc3 = data.dc3;
    this.dataToSend.fksite = Number(localStorage.getItem('pksite'));
    return this.put('/api/Activities/ChangeStatusDc3', this.dataToSend);
  }

  public ChangeStatusCS(data: any) {
    if (!this.cognitoService.IsAuhtenticated())
      this.cognitoService.LogOut();
    this.dataToSend.pkactivity = data.pkactivity;
    this.dataToSend.chemicalsubstance = data.chemicalsubstance;
    this.dataToSend.fksite = Number(localStorage.getItem('pksite'));
    return this.put('/api/Activities/ChangeStatusCS', this.dataToSend);
  }

  public ChangeStatusCriticalWork(data: any) {
    if (!this.cognitoService.IsAuhtenticated())
      this.cognitoService.LogOut();
    this.dataToSend.pkactivity = data.pkactivity;
    this.dataToSend.critical_work = data.critical_work;
    this.dataToSend.fksite = Number(localStorage.getItem('pksite'));
    return this.put('/api/Activities/ChangeStatusCriticalWork', this.dataToSend);
  }

  public GetEHSExamsByActivity(data: any) {
    if (!this.cognitoService.IsAuhtenticated())
      this.cognitoService.LogOut();
    this.dataToSend.pkactivity = data.pkactivity;
    this.dataToSend.fksite = Number(localStorage.getItem('pksite'));
    return this.post<IEHSExams[]>('/api/EHSExams/GetEHSExamsByActivity', this.dataToSend);
  }

  public AddEHSExam(data: any){
    if (!this.cognitoService.IsAuhtenticated())
      this.cognitoService.LogOut();
    this.dataToSend.pkactivity = data.pkactivity;
    this.dataToSend.fkehsexam = data.fkehsexam;
    this.dataToSend.fksite = Number(localStorage.getItem('pksite'));
    return this.post('/api/Activities/AddEHSExam', this.dataToSend);
  }

  public DisableEHSExam(data: any) {
    if (!this.cognitoService.IsAuhtenticated())
      this.cognitoService.LogOut();
    this.dataToSend.pkactivity = data.pkactivity;
    this.dataToSend.pkactivitiesexam = data.pkactivitiesexam;
    this.dataToSend.fkehsexam = data.fkehsexam;
    this.dataToSend.fksite = Number(localStorage.getItem('pksite'));
    return this.post('/api/Activities/DisableEHSExam', this.dataToSend);
  }
}
